import styled from "styled-components";
import { colorsPalettes } from "@similarweb/styles";

export const FakeFilterText = styled.span`
    color: ${colorsPalettes.carbon[100]};
    font-size: 14px;
`;
